module.exports = __webpack_public_path__ + "static/farmers_searchbuyers-cb14662ad28640af0ecae60252d4dbe1.png";